import type { RouteLocationNormalizedGeneric } from 'vue-router'
import { reportApi } from './../api/system/index'
import { isClient } from '@vueuse/core'
import { viewRiskAnyModuleApi } from '~/api/black'
import { formatGioAttributes } from '~/utils/gio'
import { tracker } from '@jctrans-materials/shared'
import { getAppId } from '~/utils/auth'

let startTime = new Date().getTime() // 初次进入页面的时间戳

let sleepTotal = 0 // 休眠时长

// 仅变量 用于记录值
let sleepTime = 0 // 记录休眠开始时间戳
let sleepDuration = 0 // 页面单次休眠时长

let initSetPageListener = false // 是否已初始化 setPageListener
let latestGioParams: Record<string, any> = {} // 始终保存最新一版埋点参数

function getReportHeaders(
  to: RouteLocationNormalizedGeneric,
  from: RouteLocationNormalizedGeneric,
) {
  const operateTime = new Date().getTime() // 获取当前操作时间
  console.log('😄😄😄😄😄', new Date(startTime))
  const allStay = startTime ? operateTime - startTime - sleepTotal : 0 // 计算活跃停留时间

  const headers = {
    'page-code': to.meta.pageCode || 'PAGE-CODE-IS-NULL',
    'Operation-Timestamp': `${operateTime}`,
    'Operation-Stay':
      from.meta.name || from.meta.pageCode ? `${allStay}` : `${0}`,
    'Operation-Sleep':
      from.meta.name || from.meta.pageCode ? `${sleepTotal}` : `${0}`,
    'Operation-Type': 'ROUTE', // 操作类型
  }
  // 重置页面初次进入时间
  startTime = operateTime
  // 重置休眠时间
  sleepTotal = 0

  return headers
}
function cclog(str: string, color = 'red') {
  console.log(`%c${str}!`, `color: ${color}; font-size: 20px;`)
}

const handleVisibilityChange = () => {
  if (document.visibilityState === 'hidden') {
    console.log('😄😄😄😄😄 初次进入当前页面的时间', new Date(startTime))
    cclog('页面进入后台')
    // 浏览器进入后台 记录休眠时间戳
    sleepTime = new Date().getTime()
  } else {
    // 浏览器进入前台
    cclog('页面进入前台')
    // 浏览器被激活，计算休眠时长并更新总停留时长
    const now = new Date().getTime()
    // 本次页面休眠的时长
    sleepDuration = now - sleepTime

    cclog(`本次休眠时长：${sleepDuration}ms`, 'blue')
    const route = useRoute()
    const systemStore = useMySystemStore()

    if (systemStore.isAPP && sleepDuration > 1000) {
      // showNotify({
      //   message: `本次休眠时长：${sleepDuration}ms, ${route.fullPath}`,
      //   color: 'blue',
      // })
      window.location.reload()
    }
    // 记录休眠总时长
    sleepTotal += sleepDuration

    // 重置休眠时间戳
    sleepTime = 0
  }
}
type ReportParams = {
  fromCode: string | null
  status: string
  eventCode: string
  extensions: {
    ERA_FROM_PAGE_PARAMS: {
      SHOPID: string | string[] | undefined
    }
    ERA_TO_PAGE_PARAMS: {
      SHOPID: string | string[] | undefined
      ERA_OPEN_SOURCE?: string | undefined
    }
    RISK_NOTICE_ID?: string
    RISK_TYPE?: string
    [key: string]: any
  }
}
const handleRiskRouteReport = (to: RouteLocationNormalizedGeneric) => {
  if (to.fullPath.includes('membership/tools')) {
    viewRiskAnyModuleApi()
  }
}
export default defineNuxtRouteMiddleware(async (to, from) => {
  const {
    userId,
    compId,
    userNameCn,
    userNameEn,
    companyNameCn,
    companyNameEn,
    compVips,
    userInfo,
    compInfo,
  } = storeToRefs(useMyUserStore())

  // ==========================================
  // 【执行边界：仅客户端 (Client) 执行】
  // ==========================================
  const buildVarProps = (targetObj: any) => {
    if (!targetObj) return {}
    const rawData = toRaw(targetObj)

    return Object.keys(rawData).reduce((acc: any, key) => {
      const val = rawData[key]
      if (val !== null && typeof val !== 'object') {
        acc[`${key}_var`] = val !== '' ? val : '-'
      }
      return acc
    }, {})
  }

  const initGioGlobalAttributes = (route: any, extensionsParams = {}) => {
    const dynamicUserProps = buildVarProps(userInfo.value)
    const dynamicCompProps = buildVarProps(compInfo.value)
    const params = {
      userId: userId.value || '-',
      company_id_ppl: compId.value || '-',
      companyId: () => compId.value || '-',
      userNameCn: () => userNameCn.value || '-',
      basic_name_CN: () => userNameCn.value || '-',
      userNameEn: () => userNameEn.value || '-',
      basic_name_EN: () => userNameEn.value || '-',
      companyNameCn: () => companyNameCn.value || '-',
      companyNameEn: () => companyNameEn.value || '-',

      // 修正：引入之前的防空指针与降维拍平逻辑
      members: () => {
        if (Array.isArray(compVips.value) && compVips.value.length > 0) {
          const codes = compVips.value.map((item) => item?.code).filter(Boolean)
          return codes.length > 0 ? codes.join(',') : '-'
        }
        return '-'
      },
      account: () => userInfo.value?.account || '-',
      projectID_var: getPrjId() || '-',
      appId: getAppId(),
      pageCode_var: route.meta.pageCode || 'PAGE-CODE-IS-NULL',
      ...dynamicUserProps,
      ...dynamicCompProps,
      ...extensionsParams,
    }
    latestGioParams = params

    if (!initSetPageListener) {
      initSetPageListener = true
      tracker.setPageListener(() => {
        tracker.setGeneralProps(
          {
            ...latestGioParams,
          },
          () => {
            console.log('🎉🎉🎉🎉🎉🎉🎉🎉 General Props Set Done')
          },
        )
        tracker.sendPage()
      })
    }
  }

  if (isClient) {
    handleRiskRouteReport(to)
    const reportHeaders = getReportHeaders(to, from)
    // 监听浏览器的可见性变化
    document.addEventListener('visibilitychange', handleVisibilityChange)
    const reportParams: ReportParams = {
      fromCode: from.meta?.pageCode?.toString() || null,
      status: 'OK',
      eventCode: `${getAppId()}.PAGE_INFO`,
      extensions: {
        ERA_FROM_PAGE_PARAMS: {
          SHOPID:
            from.path.indexOf('/company/') > -1 && from.params?.id
              ? from.params?.id
              : undefined,
        },
        ERA_TO_PAGE_PARAMS: {
          SHOPID:
            to.path.indexOf('/company/') > -1 && to.params?.id
              ? to.params?.id
              : undefined,
        },
        // 2026 年 4 月 7 日新增 GIO 埋点
        // GIO 埋点商铺 ID
        ERA_GIO_COMPANY_ID:
          to.path.indexOf('/company/') > -1 && to.params?.id
            ? to.params?.id
            : undefined,
        // GIO 埋点商机 ID
        ERA_GIO_BUSINESS_OPT_ID:
          to.path.includes('businessOpt') && to.params?.id
            ? to.params?.id
            : undefined,
        // GIO 埋点询盘 ID
        ERA_GIO_INQUIRY_ID:
          to.path.indexOf('/postFreightInquiry/') > -1 && to.params?.id
            ? to.params?.id
            : undefined,

        ERA_GIO_ROUTE_SERVICE_DETAIL_ID:
          to.path.indexOf('/routeService/detail/') > -1 && to.params?.id
            ? to.params?.id
            : undefined,
      },
    }

    // 风控相关埋点 PV/UV
    if (
      from.meta.pageCode === 'ERA.UC.TOOLS.RiskAssurance.ProcessIntroduction' ||
      from.meta.pageCode === 'ERA.UC.TOOLS.RISK.PROCESS.DETAIL' ||
      from.meta.pageCode === 'ERA.UC.TOOLS.RiskPrevention.RiskCase' ||
      from.meta.pageCode === 'ERA.UC.TOOLS.RiskPrevention.CaseDetail' ||
      from.meta.pageCode === 'ERA.UC.TOOLS.RiskPrevention.RiskNotice' ||
      from.meta.pageCode === 'ERA.UC.TOOLS.RiskPrevention.RiskNoticeDetail'
    ) {
      if (from.params.id || to.params.id) {
        const riskType = from.meta.pageCode.includes('Case')
          ? 'RISK_CASE'
          : from.meta.pageCode.includes('Notice')
            ? 'RISK_NOTICE'
            : 'RISK_PROCESS'
        reportParams.extensions.RISK_TYPE = riskType
        reportParams.extensions.RISK_NOTICE_ID =
          (from.params.id || to.params.id) + ''
      }
    }

    // 如果ERA_OPEN_SOURCE存在，则添加到reportParams中
    if (to.query.ERA_OPEN_SOURCE) {
      reportParams.extensions.ERA_TO_PAGE_PARAMS.ERA_OPEN_SOURCE =
        to.query.ERA_OPEN_SOURCE.toString()
    }

    try {
      initGioGlobalAttributes(to, formatGioAttributes(reportParams.extensions))
      reportApi(reportParams, reportHeaders)
      gioPageReport(reportParams, reportHeaders)
    } catch (error) {
      // throw createError(error)
    }
  }
  // return 'Hello Nitro'
})
